import { AppThemeProvider } from "./AppTheme";
import { MUIThemeProvider } from "./MUITheme";

export function RootThemeProvider({ children }) {
    return (
        <AppThemeProvider>
            <MUIThemeProvider>{children}</MUIThemeProvider>
        </AppThemeProvider>
    );
}
